import React from "react"
import Intro from "src/components/_shared/intro/intro"
import SEO from "components/seo"
import { graphql, useStaticQuery } from "gatsby"
import { useContent } from "src/utils/hooks"

// import SEO from 'src/components/_shared/seo';

const Index = () => {
  const seoquery = useStaticQuery(graphql`
    query {
      chapter {
        pl {
          landing {
            seo {
              title {
                content
              }
              description {
                content
              }
              image {
                content
              }
            }
          }
        }
      }
    }
  `)
  const { resolve } = useContent(seoquery.chapter.pl)

  if (typeof window === "undefined") {
    return (
      <SEO
        title={seoquery.chapter.pl.landing.seo.title.content}
        lang="pl"
        description={resolve("LANDING_SEO_DESCRIPTION")}
      />
    )
  }

  return (
    <>
      <SEO
        title={resolve("LANDING_SEO_TITLE")}
        lang="pl"
        description={resolve("LANDING_SEO_DESCRIPTION")}
      />
      <Intro locale="pl" />
    </>
  )
}
export default Index
